<template>
    <div class="standard-detail">
        <div class="d-flex justify-content-between pb-3 px-3">
            <h5 class="text-primary m-0">Filename</h5>
            <strong class="small text-primary d-inline-flex align-items-center">
                <i class="material-icons pr-2">save_alt</i>Download filetype
            </strong>
        </div>
        <div v-for="spec in resources" :key="spec.id" class="standard-detail--item d-flex">
            <strong class="flex-grow-1 small text-blue-dark">{{ spec.name }}</strong>
            <a v-if="spec.file_rfa"
               v-on:click="() => downloadModal(spec.file_rfa)"
               href="javascript:void(0)"
               class="px-3"
               >RFA</a>
            <a v-if="spec.file_rvt"
               v-on:click="() => downloadModal(spec.file_rvt)"
               href="javascript:void(0)"
               class="px-3"
               >RVT</a>
            <a v-if="spec.file_dwg"
               v-on:click="() => downloadModal(spec.file_dwg)"
               href="javascript:void(0)"
               class="px-3"
               >DWG</a>
            <a v-if="spec.file_dxf"
               v-on:click="() => downloadModal(spec.file_dxf)"
               href="javascript:void(0)"
               class="px-3"
               >DXF</a>
            <a v-if="spec.file_mod"
               v-on:click="() => downloadModal(spec.file_mod)"
               href="javascript:void(0)"
               class="px-3"
               >MOD</a>
            <a v-if="spec.file_pdf"
               v-on:click="() => downloadModal(spec.file_pdf)"
               href="javascript:void(0)"
               class="px-3"
               >PDF</a>
            <a v-if="spec.file_image"
               v-on:click="() => downloadModal(spec.file_image)"
               href="javascript:void(0)"
               class="px-3"
               >JPG</a>
        </div>

        <download-modal-component
            v-on:hide="() => showModal = false"
            :show="showModal"
            :asset="currentAsset"
            :config="config"
            ></download-modal-component>
    </div>
</template>
<script>
import M from 'moment';
import UtilsMixin from './UtilsMixin';
import DownloadModalComponent from './DownloadModalComponent';

export default {
    data() {
        return {
            search: null,
            showModal: false,
            currentFilter: null,
            currentSort: null,
            currentAsset: null,
        }
    },

    mounted() {

    },

    props: ['initialData', 'config'],

    components: {
        DownloadModalComponent,
    },

    mixins: [UtilsMixin],

    watch: {

    },

    computed: {
        formConfig() {
            return _.get(this.config, 'form', {});
        },

        resources() {
            return _.chain(this.initialData)
                .get('resources')
                .value();
        },

        readonly() {
            return _.get(this.config, 'readonly');
        },
    },

    methods: {
        downloadModal(asset) {
            this.currentAsset = asset;
            this.showModal = true;
        },

        getFilePath(file) {
            return this.readonly ? this._.filePath(file) + '#toolbar=0' : this._.filePath(file, true);
        },
    }
}
</script>




// WEBPACK FOOTER //
// resources/assets/site/js/components/AssetListComponent.vue